<template>
  <div class="productWrap">
    <div class="productDeco" @click.prevent="handleClick(product, $event)">
      <!-- [결제하기] product.type이  3 : 배송 / 4: 펀딩-->
      <span
        v-if="$route.name === 'order' && (isShippingProduct || isEventProduct)"
        class="badge productBadge"
        :class="
          product.type === 3
            ? '_isDelivery'
            : isEventProduct
            ? '_isEvent'
            : '_isFunding'
        "
      >
        {{
          product.type === 3
            ? '배송상품'
            : isEventProduct
            ? '응모상품'
            : '펀딩상품'
        }}
      </span>
      <span class="productShopname">{{ product.serviceName }}</span>
      <span class="productNum">{{ product.productId }}</span>
      <div v-if="isList" class="productImg" ref="productImg">
        <span
          v-if="isShippingProduct || isEventProduct"
          class="badge productBadge"
          :class="
            product.type === 3
              ? '_isDelivery'
              : isEventProduct
              ? '_isEvent'
              : '_isFunding'
          "
        >
          {{
            product.type === 3
              ? '배송상품'
              : isEventProduct
              ? '응모상품'
              : '펀딩상품'
          }}
        </span>
        <img v-if="productImgUrl" :src="productImgUrl" alt="" />
        <img v-else src="../../assets/images/temp/default_thumb.png" alt="" />
        <template>
          <!-- main product list 에서 품절, 준비중, 종료 표시 -->
          <div class="productStatusMask" v-if="product.productStatus !== 2">
            <span class="productStatus">{{ productStatusNotSale }}</span>
          </div>
          <div
            v-else-if="$route.name === 'cart' && isCountAvailable === false"
            class="productStatus"
          >
            수량초과
          </div>
        </template>
      </div>
      <div v-if="isShippingProduct || isEventProduct">
        <!-- 최근, 검색 -->
        <span
          v-show="
            isList && ($route.name === 'recent' || $route.name === 'search')
          "
          class="badge productBadge"
          :class="
            product.type === 3
              ? '_isDelivery'
              : isEventProduct
              ? '_isEvent'
              : '_isFunding'
          "
        >
          {{
            product.type === 3
              ? '배송상품'
              : isEventProduct
              ? '응모상품'
              : '펀딩상품'
          }}
        </span>
        <span class="productName">{{ product.productName }}</span>
      </div>
      <template v-else>
        <span class="productName">{{ product.productName }}</span>
      </template>
      <span class="productCate" v-if="product.rank">
        <span class="cateRank">{{ product.rank }}</span>
      </span>
      <div v-if="isCountVisible" class="productCount">
        <strong>{{ product.purchaseCount }}</strong>
        개
      </div>
      <span class="productSale" v-if="!isSaleAfter">
        {{
          isDiscount
            ? `${product.displayPrice.addComma()}${product.currencyUnit}`
            : ''
        }}
      </span>

      <span class="productPrice">
        {{ product.price.addComma() }}{{ product.currencyUnit }}
        <button type="button" class="btCartPut" v-if="isCartbuttonVisible">
          <span class="icon iconCartPut"></span>
          <span class="accessibilityHide">장바구니 담기</span>
        </button>

        <span
          v-if="!isList && (isShippingProduct || isEventProduct)"
          class="badge productBadge"
          :class="
            product.type === 3
              ? '_isDelivery'
              : isEventProduct
              ? '_isEvent'
              : '_isFunding'
          "
        >
          {{
            product.type === 3
              ? '배송상품'
              : isEventProduct
              ? '응모상품'
              : '펀딩상품'
          }}
        </span>
      </span>

      <span class="productSale" v-if="isSaleAfter">
        {{
          isDiscount
            ? `${product.displayPrice.addComma()}${product.currencyUnit}`
            : ''
        }}
      </span>
      <span v-if="isRewardUse && product.enableRewardUse" class="productReward">
        <img
          src="~@/assets/images/text_reward.png"
          width="49"
          height="14"
          alt="리워드"
        />
      </span>
      <span class="productComment">{{ product.comment }}</span>
    </div>
  </div>
</template>

<script>
import {
  findAncestor,
  beforeSendLog,
  convertProductStatusToKor,
  checkCountLimit
} from '@/utils'
import { mapActions } from 'vuex'

export default {
  name: 'ProductItem',
  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isSaleAfter: {
      type: Boolean,
      default: false
    },
    isCartbuttonVisible: {
      type: Boolean,
      default: false
    },
    isCountVisible: {
      type: Boolean,
      default: false
    },
    isList: {
      // 제품 상세 보기에선 이미지 노출 안함
      type: Boolean,
      default: true
    },
    isRewardUse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    isDiscount() {
      return this.product.displayPrice - this.product.price > 0
    },
    productUrl() {
      return `/product/${this.product.productId}`
    },
    productImgUrl() {
      return (
        this.product.imageUrl ||
        (this.product.productImageList && this.product.productImageList[0])
      )
    },
    productStatusNotSale() {
      return convertProductStatusToKor(this.product.productStatus)
    },
    isCountAvailable() {
      return checkCountLimit(this.product.purchaseCount, this.product, true)
    },
    isShippingProduct() {
      return this.product.type === 3 || this.product.type === 4
    },
    isEventProduct() {
      return this.product.type === 7
    }
  },
  methods: {
    ...mapActions('cart', ['addProductOfCart']),
    ...mapActions('modal', ['openModal']),
    handleClick(product, e) {
      if (this.$route.name === 'order') {
        return false // 주문 창에서는 제품을 선택해도 클릭 불가
      } else if (this.$route.name !== 'product') {
        const findCart = findAncestor(e.target, 'btCartPut')
        if (findCart) {
          // 제품 상태가 SALE 인 경우에만 장바구니 버튼 동작
          if (product.productStatus === 2) {
            beforeSendLog('Cart', { ProductID: product.productId })
            this.addProductOfCart({ ...product, purchaseCount: 1 })
          } else {
            this.openModal({
              type: 'alert',
              message:
                '구매 가능 시간이 아니거나, 품절 상태로 현재 구매가 불가능한 상품입니다.'
            })
          }
        } else {
          beforeSendLog('Product', {
            ProductID: product.productId,
            ProductType: product.type
          })
          this.$router.push({
            name: 'product',
            params: { productId: product.productId.toString() }
          })
        }
      }
    },
    cateClass: function(cate) {
      switch (cate) {
        case '신규':
          return 'cateNew'
        case '인기':
          return 'cateHot'
      }
    },
    setFrameSize() {
      const frameWidth = this.$refs.productImg.HTMLElement.offsetWidth
      console.error(frameWidth)
    }
  }
}
</script>

<style lang="scss"></style>
